import React, { Component, createRef } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { TextBox } from "../../Components/InputElements";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import copy from 'clipboard-copy';
import Swal from "sweetalert2";
import PageTitle from "../../Components/PageTitle";

class NewLetterSandBox extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            company_letter_content: "",
            previewClicked: false,
            company_letter_id: 0,
            company_letter_title: "",
            company_letter_head: [],
            markings: "0,0,0,0",
            letterhead_url: null,
            company_letter_head_id: 0,
            errors: {},
            divDimensions: { width: 0, height: 0 }, // To store dynamic dimensions
            pages: [
                { id: 1, content: "", ref: React.createRef() }, // Track content per page
            ],
        };
        this.debounceTimer = null;
        this.imgRef = React.createRef();
        this.divRef = React.createRef();
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetLetterHeadsList();
        });
    }
    // handleInputChange = (e) => {
    //   this.setState({
    //     [e.target.name]: e.target.value,
    //   });
    // };

    handleInputChange = (e) => {
        const { name, value } = e.target;

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {
            company_letter_title: this.state.company_letter_title,
            company_letter_content: this.state.company_letter_content,
            company_letter_head_id: this.state.company_letter_head_id,
        };

        axios
            .post(`${apiURL}Masters/CreateCompanyLetter`, formData, { headers })
            .then((response) => {
                const { success } = response.data;
                if (success === true) {
                    this.setState({
                        company_letter_head_id: 0,
                        company_letter_title: "",
                        letterhead_url: null,
                        markings: "0,0,0,0",
                        company_letter_content: "",
                    });

                    this.setState({ loadingList: true }, (prevState) => { });
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? "Success" : "Failed"
                            }</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? "success" : "error",
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    });
                } else {
                    Swal.close();
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? "Success" : "Failed"
                            }</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? "success" : "error",
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    });
                    this.setState({ loadingList: true }, (prevState) => { });
                }
            });
    };

    validateForm = () => {
        const errors = {};

        // Validate individual fields
        if (!this.state.company_letter_head_id) {
            errors.company_letter_head = 'Letter Head is required';
        }

        if (!this.state.company_letter_title) {
            errors.company_letter_title = 'Letter Title is required';
        }

        if (!this.state.company_letter_content) {
            errors.company_letter_content = 'Letter Content is required';
        }

        // Add more validation rules as needed

        return errors;
    };

    GetLetterHeadsList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}Masters/GetLetterHeads`, { headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        company_letter_head: data.data.map((row) => ({
                            value: row.company_letter_head_id,
                            label: row.company_letter_head_name,
                            markings: row.markings,
                            letterhead_url: row.letterhead_url,
                        })),
                    }));
                }
            });
    };


    handleEditorChange = (event, editor) => {
        // const value = event.target.value;

        // Clear the previous timeout if the user is still typing
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        // Set a new timeout to call the function after 1 second
        this.debounceTimer = setTimeout(() => {
            const company_letter_content = editor.getData();
            // Clear the error for the company_letter_content field
            const errors = { ...this.state.errors };
            delete errors.company_letter_content;

            // this.setState({ 
            //   company_letter_content,
            //   errors: errors, // Update errors object
            // });
            // console.log(`company_letter_content`, company_letter_content);

            this.handleContentChange(company_letter_content)
        }, 1000);

    };

    componentDidUpdate(prevProps, prevState) {
        // Adjust div dimensions after the image loads
        if (this.imgRef.current && prevState.letterhead_url !== this.state.letterhead_url) {
            this.setState({
                divDimensions: {
                    width: this.imgRef.current.offsetWidth,
                    height: this.imgRef.current.offsetHeight,
                },
            });
            // console.log(`this.imgRef.current.offsetWidth, this.imgRef.current.offsetHeight`,this.imgRef.current.offsetWidth,this.imgRef.current.offsetHeight)
        }
    }

    handleContentChange = (newContent) => {
        const { scrollHeight, clientHeight } = this.divRef.current;
        // Allow text removal or addition only if it's within limits
        if (scrollHeight <= clientHeight || newContent.length < this.state.company_letter_content.length) {
            this.setState({ company_letter_content: newContent });
            this.updatePreviewData(newContent);
        }
        else if (scrollHeight <= clientHeight) {
            this.setState((prevState) => ({
                pages: [
                    ...prevState.pages,
                    { id: prevState.pages.length + 1, content: "", ref: createRef() },
                ],
            }));
        }
    };

    // handleContentChange = (newContent) => {
    //     const { pages, divDimensions } = this.state;

    //     // Update content for the current (last) page
    //     const lastPage = pages[pages.length - 1];
    //     lastPage.content = newContent;

    //     // Check if overflow occurs in the last page div
    //     if (lastPage.ref.current) {
    //         const { scrollHeight, clientHeight } = lastPage.ref.current;

    //         if (scrollHeight > clientHeight) {
    //             // If overflowed, create a new page
    //             this.addNewPage();
    //         }
    //     }

    //     // Update the content state to re-render
    //     this.setState({ company_letter_content: newContent, pages });
    // };

    // addNewPage = () => {
    //     this.setState((prevState) => ({
    //         pages: [
    //             ...prevState.pages,
    //             { id: prevState.pages.length + 1, content: "", ref: createRef() },
    //         ],
    //     }));
    // };

    // handleContentChange = (newContent) => {
    //     let remainingContent = newContent;
    //     const newPages = [];

    //     // Loop through each page and check if the content fits
    //     this.state.pages.forEach((val, idx) => {
    //         // Ensure the ref is properly attached before accessing scrollHeight and clientHeight
    //         console.log("handleContentChange =>", val);
    //         const pageRef = val.ref.current;
    //         if (pageRef) {
    //             const { scrollHeight, clientHeight } = pageRef;

    //             // If current content fits
    //             if (scrollHeight <= clientHeight) {
    //                 // Assign remaining content to the current page
    //                 newPages.push({
    //                     ...val,
    //                     content: remainingContent,
    //                 });
    //                 remainingContent = ''; // Clear remaining content
    //             } else {
    //                 // If content overflows, split the content and add the part that fits
    //                 const contentToAdd = remainingContent.slice(0, clientHeight); // Split based on clientHeight
    //                 newPages.push({
    //                     id: val.id,
    //                     content: contentToAdd,
    //                     ref: React.createRef(), // New ref for the next page
    //                 });
    //                 remainingContent = remainingContent.slice(contentToAdd.length); // Remove added content from remaining
    //             }
    //         }
    //     });

    //     // If there's still remaining content, create additional pages
    //     while (remainingContent.length > 0) {
    //         newPages.push({
    //             content: remainingContent.slice(0, 500), // Limit the size to fit within the height
    //             ref: React.createRef(), // New ref for the next page
    //         });
    //         remainingContent = remainingContent.slice(500); // Slice off the content we've added
    //     }

    //     // Update the state with new pages
    //     this.setState({
    //         pages: newPages,
    //     });
    // };

    // handleContentChange = (newContent) => {
    //     const { pages } = this.state; // Get the current pages
    //     const newPages = [];
    //     let remainingContent = newContent;

    //     // Go through each page and check if the content fits
    //     pages.forEach((val, idx) => {
    //         const pageRef = val.ref.current;

    //         if (pageRef) {
    //             const { clientHeight } = pageRef; // Available height for the content
    //             const contentToFit = remainingContent.slice(0, clientHeight); // Simulated fit content

    //             // Add this content to the current page
    //             newPages.push({
    //                 id: val.id,
    //                 content: contentToFit,
    //                 ref: val.ref,
    //             });

    //             // Remove the content we've added from the remaining content
    //             remainingContent = remainingContent.slice(contentToFit.length);
    //         }
    //     });

    //     // Add new pages for the remaining content
    //     while (remainingContent.length > 0) {
    //         const contentToFit = remainingContent.slice(0, 500); // Limit per page, adjust based on content fit
    //         newPages.push({
    //             id: newPages.length + 1,
    //             content: contentToFit,
    //             ref: React.createRef(),
    //         });
    //         remainingContent = remainingContent.slice(contentToFit.length);
    //     }

    //     // Ensure at least one page exists
    //     if (newPages.length === 0) {
    //         newPages.push({
    //             id: 1,
    //             content: '',
    //             ref: React.createRef(),
    //         });
    //     }

    //     // Update the state with the recalculated pages
    //     this.setState({
    //         pages: newPages,
    //     });
    // };

    // 500 char capping logic
    // handleContentChange = (newContent) => {
    //     const charLimitPerPage = 1500; // Max characters per page
    //     const newPages = [];

    //     // Split content into chunks of 500 characters
    //     let remainingContent = newContent;

    //     while (remainingContent.length > 0) {
    //         const contentToFit = remainingContent.slice(0, charLimitPerPage);
    //         newPages.push({
    //             id: newPages.length + 1,
    //             content: contentToFit,
    //             ref: React.createRef(),
    //         });
    //         remainingContent = remainingContent.slice(charLimitPerPage);
    //     }

    //     // If no content, reset to a single empty page
    //     if (newPages.length === 0) {
    //         newPages.push({
    //             id: 1,
    //             content: '',
    //             ref: React.createRef(),
    //         });
    //     }

    //     // Update the state with the new pages
    //     this.setState({
    //         pages: newPages,
    //     });
    // };

    // working code for multiple pages 
    // handleContentChange = (newContent) => {
    //     const letter_markings = this.state.markings.split(",");
    //     const { width, height } = this.state.divDimensions || { width: 0, height: 0 };
    //     const [paddingTop, paddingBottom, paddingLeft, paddingRight] = letter_markings || [0, 0, 0, 0];

    //     // Calculate the actual usable height and width
    //     const usableHeight = height - (parseInt(paddingTop) + parseInt(paddingBottom));
    //     const usableWidth = width - (parseInt(paddingLeft) + parseInt(paddingRight));

    //     console.log('Usable Dimensions:', { usableWidth, usableHeight });

    //     const newPages = [];
    //     let remainingContent = newContent;

    //     // Create and reuse a single temporary div for measuring text
    //     const tempDiv = document.createElement('div');
    //     tempDiv.style.width = `${usableWidth}px`;
    //     tempDiv.style.padding = '0'; // Padding is already subtracted
    //     tempDiv.style.position = 'absolute';
    //     tempDiv.style.visibility = 'hidden';
    //     tempDiv.style.lineHeight = '1.2'; // Ensure consistent text measurement
    //     tempDiv.style.fontSize = '16px'; // Match the font size
    //     document.body.appendChild(tempDiv);

    //     // Create pages by incrementally adding content until the height is exceeded
    //     while (remainingContent.length > 0) {
    //         const newRef = React.createRef();
    //         const pageObj = {
    //             id: newPages.length + 1,
    //             content: '',
    //             ref: newRef,
    //         };

    //         newPages.push(pageObj);

    //         // Use binary search to find the maximum fitting text
    //         let low = 0, high = remainingContent.length, splitIndex = 0;
    //         while (low <= high) {
    //             const mid = Math.floor((low + high) / 2);
    //             tempDiv.textContent = remainingContent.slice(0, mid);

    //             if (tempDiv.scrollHeight <= usableHeight) {
    //                 splitIndex = mid; // Mid fits, try for more
    //                 low = mid + 1;
    //             } else {
    //                 high = mid - 1; // Mid doesn't fit, try less
    //             }
    //         }

    //         // Assign fitting content to this page
    //         pageObj.content = remainingContent.slice(0, splitIndex);
    //         remainingContent = remainingContent.slice(splitIndex);
    //         console.log("pageObj", pageObj);

    //         // If no content was added to the page, break the loop
    //         if (pageObj.content.length === 0) {
    //             break;
    //         }
    //     }

    //     // Clean up temporary div
    //     document.body.removeChild(tempDiv);

    //     // Ensure there's at least one page
    //     if (newPages.length === 0) {
    //         newPages.push({
    //             id: 1,
    //             content: '',
    //             ref: React.createRef(),
    //         });
    //     }

    //     console.log('New Pages:', newPages);

    //     // Update the state to re-render with the new pages
    //     this.setState({ pages: newPages });
    // };

    // handleContentChange = (newContent) => {
    //     // Sanitize the pasted content
    //     const sanitizedContent = this.sanitizeContent(newContent);

    //     // Get available height and width for the page (excluding padding)
    //     const { width, height } = this.state.divDimensions || { width: 0, height: 0 };
    //     const [paddingTop, paddingBottom, paddingLeft, paddingRight] = this.state.markings.split(",");
    //     const usableHeight = height - (parseInt(paddingTop) + parseInt(paddingBottom));
    //     const usableWidth = width - (parseInt(paddingLeft) + parseInt(paddingRight));

    //     console.log('Usable Dimensions:', { usableWidth, usableHeight });

    //     // Initialize the pages array
    //     const newPages = [];
    //     let remainingContent = sanitizedContent;

    //     // Create a temporary div for measuring the content's scroll height
    //     const tempDiv = document.createElement('div');
    //     tempDiv.style.width = `${usableWidth}px`;
    //     tempDiv.style.padding = '0';  // No extra padding
    //     tempDiv.style.position = 'absolute';
    //     tempDiv.style.visibility = 'hidden';
    //     tempDiv.style.fontSize = '16px';
    //     tempDiv.style.fontFamily = 'Arial';
    //     tempDiv.style.lineHeight = '1.2'; // Ensure consistency in line height
    //     document.body.appendChild(tempDiv);

    //     // Loop to create pages
    //     while (remainingContent.length > 0) {
    //         const pageObj = { id: newPages.length + 1, content: '', ref: React.createRef() };
    //         newPages.push(pageObj);

    //         let low = 0, high = remainingContent.length, splitIndex = 0;

    //         // Use binary search to find the split point (page break)
    //         while (low <= high) {
    //             const mid = Math.floor((low + high) / 2);
    //             tempDiv.textContent = remainingContent.slice(0, mid);

    //             if (tempDiv.scrollHeight <= usableHeight) {
    //                 splitIndex = mid;  // If it fits, try for more content
    //                 low = mid + 1;
    //             } else {
    //                 high = mid - 1;  // If it overflows, try less content
    //             }
    //         }

    //         // Split content and prepare for the next page
    //         pageObj.content = remainingContent.slice(0, splitIndex);
    //         remainingContent = remainingContent.slice(splitIndex);

    //         // If no content was added, exit the loop to prevent infinite loop
    //         if (pageObj.content.length === 0) break;
    //     }

    //     // Clean up the temporary div
    //     document.body.removeChild(tempDiv);

    //     // If no pages were created, add a fallback page with empty content
    //     if (newPages.length === 0) {
    //         newPages.push({ id: 1, content: '', ref: React.createRef() });
    //     }

    //     console.log('Created Pages:', newPages);

    //     // Update the state with the new pages
    //     this.setState({ pages: newPages });
    // };

    // Function to sanitize the content by removing hidden Word formatting characters
    // sanitizeContent = (content) => {
    //     // Replace non-breaking spaces and zero-width spaces, and clean up extra spaces/newlines
    //     return content.replace(/\u00a0/g, ' ').replace(/\u200b/g, '').replace(/\r?\n|\r/g, ' ').replace(/\s+/g, ' ').trim();
    // };


    // handleContentChange = (newContent) => {

    //     const letter_markings = this.state.markings.split(",");

    //     const { width, height } = this.state.divDimensions || { width:0, height:0 };
    //     const [paddingTop, paddingBottom, paddingLeft, paddingRight] = letter_markings || [0, 0, 0, 0];
    // // console.log(`width, height, paddingTop, paddingBottom, paddingLeft, paddingRight`,width, height, paddingTop, paddingBottom, paddingLeft, paddingRight);

    //     // Calculate the actual usable height and width
    //     const usableHeight = height - (parseInt(paddingTop) + parseInt(paddingBottom));
    //     const usableWidth = width - (parseInt(paddingLeft) + parseInt(paddingRight));

    //     console.log('Usable Dimensions:', { usableWidth, usableHeight });

    //     const newPages = [];
    //     let remainingContent = newContent;

    //     // Temporary div to simulate text measurement
    //     const tempDiv = document.createElement('div');
    //     tempDiv.style.width = `${usableWidth}px`;
    //     tempDiv.style.padding = '0'; // Padding is already subtracted
    //     tempDiv.style.position = 'absolute';
    //     tempDiv.style.visibility = 'hidden';
    //     tempDiv.style.lineHeight = '1.2'; // Ensure consistent text measurement
    //     tempDiv.style.fontSize = '16px'; // Match the font size
    //     document.body.appendChild(tempDiv);

    //     while (remainingContent.length > 0) {
    //         const newRef = React.createRef();
    //         const pageObj = {
    //             id: newPages.length + 1,
    //             content: '',
    //             ref: newRef,
    //         };

    //         newPages.push(pageObj);

    //         // Incrementally add characters to fit within height
    //         let splitIndex = 0;
    //         for (let i = 1; i <= remainingContent.length; i++) {
    //             tempDiv.textContent = remainingContent.slice(0, i);

    //             console.log(
    //                 `Checking text "${remainingContent.slice(0, i)}":`,
    //                 `ScrollHeight: ${tempDiv.scrollHeight}, UsableHeight: ${usableHeight}`
    //             );

    //             if (tempDiv.scrollHeight > usableHeight) {
    //                 splitIndex = i - 1;
    //                 break;
    //             }
    //         }

    //         // If no split index is found, all remaining content fits
    //         if (splitIndex === 0) splitIndex = remainingContent.length;

    //         // Assign fitting content to this page
    //         pageObj.content = remainingContent.slice(0, splitIndex);
    //         remainingContent = remainingContent.slice(splitIndex);
    //     }

    //     // Clean up temporary div
    //     document.body.removeChild(tempDiv);

    //     // Ensure there's at least one page
    //     if (newPages.length === 0) {
    //         newPages.push({
    //             id: 1,
    //             content: '',
    //             ref: React.createRef(),
    //         });
    //     }

    //     // console.log('New Pages:', newPages);

    //     this.setState({ pages: newPages });
    // };








    handlePreviewClick = () => {
        this.setState({ previewClicked: true });
    };

    updatePreviewData = (company_letter_content) => {
        // You can modify this part based on your specific requirements
        // For simplicity, this example uses the company_letter_content as-is
    };

    handleSelectOption = (e) => {
        // Clear the error for the company_letter_head field
        const errors = { ...this.state.errors };
        delete errors.company_letter_head;

        this.setState(
            {
                markings: e.markings,
                letterhead_url: e.letterhead_url,
                company_letter_head_id: e.value,
                errors: errors,
                pages: [
                    { id: 1, content: "", ref: React.createRef() }, // Track content per page
                ],
            },
            (prevState) => { }
        );

    };

    handleCopyClick = (code) => {
        copy(code);
        toast.success(`Code Has Been Copied! ${code}`, { autoClose: 1500 });
    };


    render() {
        const { letterhead_url, company_letter_content, previewClicked, pages, errors, divDimensions } = this.state;
        const letter_markings = this.state.markings.split(",");
        return (
            <>
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid mt-3">
                            <PageTitle title={"New Letter"} primary={`Home`} />
                            <div className="d-flex justify-content-end mb-3">
                                <button
                                    type="button"
                                    className="btn btn-primary waves-effect right waves-light btn-label mt-3"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasRight"
                                    aria-controls="offcanvasRight"
                                >
                                    <i className="ri-code-s-slash-line label-icon align-middle fs-16" />{" "}
                                    Placeholder Keys
                                </button>
                            </div>
                            <div
                                className="offcanvas offcanvas-end"
                                tabIndex={-1}
                                id="offcanvasRight"
                                aria-labelledby="offcanvasRightLabel"
                            >
                                <div className="offcanvas-header">
                                    <h5 id="offcanvasRightLabel"> Placeholder Keys</h5>
                                    <button
                                        type="button"
                                        className="btn-close text-reset"
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                    />
                                </div>

                                <div className="offcanvas-body">
                                    <table class="table table-hover table-bordered border-primary table-nowrap">
                                        <thead className="bg-primary text-light bg-gradient">
                                            <tr>
                                                <th scope="col">Names</th>
                                                <th scope="col">Code</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Employee Name</td>
                                                <td onClick={() => this.handleCopyClick("##employee_name##")} style={{ cursor: "pointer" }}>##employee_name##</td>
                                            </tr>
                                            <tr>
                                                <td>Department Title</td>
                                                <td onClick={() => this.handleCopyClick("##department_title##")} style={{ cursor: "pointer" }}>##department_title##</td>
                                            </tr>
                                            <tr>
                                                <td>Designation Title</td>
                                                <td onClick={() => this.handleCopyClick("##designation_title##")} style={{ cursor: "pointer" }}>##designation_title##</td>
                                            </tr>
                                            <tr>
                                                <td>Grade Title</td>
                                                <td onClick={() => this.handleCopyClick("##grade_title##")} style={{ cursor: "pointer" }}>##grade_title##</td>
                                            </tr>
                                            <tr>
                                                <td>Location Title</td>
                                                <td onClick={() => this.handleCopyClick("##location_title##")} style={{ cursor: "pointer" }}>##location_title##</td>
                                            </tr>
                                            <tr>
                                                <td>Employee Joining Date</td>
                                                <td onClick={() => this.handleCopyClick("##employee_joining_date##")} style={{ cursor: "pointer" }}>##employee_joining_date##</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4" style={{ marginBottom: "" }}>
                                    <div className="card">
                                        <div className="card-header">
                                            {/* <div></div> */}
                                            <div
                                                className="col-md-12"
                                                style={{ marginBottom: "20px" }}
                                            >
                                                <label>Select Letter Head</label>
                                                <div className="w-100">
                                                    <Select
                                                        options={this.state.company_letter_head}
                                                        value={this.state.company_letter_head.find(option => option.value === this.state.company_letter_head_id) || null}
                                                        onChange={this.handleSelectOption}
                                                        hint={`Select`}
                                                    />
                                                    {errors.company_letter_head && <div className="text-danger">{errors.company_letter_head}</div>}
                                                </div>
                                            </div>
                                            <div
                                                className="col-md-12"
                                                style={{ marginBottom: "20px" }}
                                            >
                                                <TextBox
                                                    type="text"
                                                    id="company_letter_title"
                                                    name="company_letter_title"
                                                    value={this.state.company_letter_title}
                                                    label="Letter Title "
                                                    hint="Enter Letter Title"
                                                    change={this.handleInputChange}
                                                />
                                                {errors.company_letter_title && <div className="text-danger">{errors.company_letter_title}</div>}
                                            </div>
                                            <div className="col-md-12" style={{ marginBottom: "" }}>
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    data={this.state.company_letter_content}
                                                    name={"company_letter_content"}
                                                    onChange={this.handleEditorChange}
                                                />
                                                {errors.company_letter_content && <div className="text-danger">{errors.company_letter_content}</div>}
                                                <div className="d-flex justify-content-end">
                                                    <button
                                                        type="button"
                                                        className={`${this.state.company_letter_head_id !== 0 ? ('') : 'd-none'} btn btn-primary btn-label mt-3 mx-2`}
                                                        onClick={this.handlePreviewClick} // Add onClick handler for preview button
                                                    >
                                                        Preview
                                                        <i className="ri-eye-line label-icon align-middle fs-16" />
                                                    </button>

                                                    <button
                                                        type="submit"
                                                        onClick={this.handleSubmit}
                                                        className="btn btn-success btn-label waves-effect mt-3 mx-"
                                                    >
                                                        <i className="ri-checkbox-circle-line label-icon align-middle fs-16" />{" "}
                                                        Create
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Preview Tab */}
                                <div className="col-8" style={{ marginBottom: "" }}>
                                    <div className="card">
                                        <div className="card-header">
                                            <div
                                                className="row mt-1 d-flex align-items-center"
                                                style={{ marginTop: "-20px" }}
                                            >
                                                <div className="col-md-8">
                                                    <h4 className="card-title mb-0">Preview Tab</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            {/* Use the company_letter_content only if previewClicked is true */}
                                            {/* <div style={{ width:'105mm', height:'148mm',  backgroundImage: `url('${this.state.letterhead_url}')`}} > */}

                                            {/* <div className="bubble-editor"
                        style={{
                          position: "absolute",
                          width: "100%", height: "297mm",
                          // width: `${letter_markings[0] + letter_markings[1] - 210 }mm`,
                          // height: `${letter_markings[2] + letter_markings[3] - 297 }mm`,
                          marginTop: letter_markings[0] + "mm",
                          marginBottom: letter_markings[1] + "mm",
                          marginLeft: letter_markings[2] + "mm",
                          marginRight: letter_markings[3] + "mm",
                          overflow: "hidden"
                        }} dangerouslySetInnerHTML={{ __html: previewClicked ? this.state.company_letter_content : "", }} />
                      {this.state.letterhead_url !== null ? (
                        <img
                          src={this.state.letterhead_url}
                          style={{ width: "100%", height: "297mm" }}
                          alt="Letterhead"
                        />
                      ) : (
                        <div>
                          
                          <h4 className="text-muted">Please Select Letter Head ✉...</h4>
                        </div>
                      )} */}
                                            {/* #2. */}
                                            <div
                                                className="bubble-editor"
                                                ref={this.divRef}
                                                style={{
                                                    position: "absolute",
                                                    width: divDimensions.width ? `${divDimensions.width}px` : "0",
                                                    height: divDimensions.height ? `${divDimensions.height}px` : "0",
                                                    paddingTop: letter_markings[0] + "mm",
                                                    paddingBottom: letter_markings[1] + "mm",
                                                    paddingLeft: letter_markings[2] + "mm",
                                                    paddingRight: letter_markings[3] + "mm",
                                                    maxHeight: divDimensions.height
                                                        ? `${divDimensions.height - letter_markings[0] - letter_markings[1]}px`
                                                        : "0", // Subtract top and bottom padding from height
                                                    overflow: "hidden", // Use 'auto' if you want to make the content scrollable
                                                    // border: "1px solid #ccc",
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: previewClicked ? company_letter_content : "",
                                                }}
                                            />
                                            {letterhead_url ? (
                                                <img
                                                    src={letterhead_url}
                                                    ref={this.imgRef}
                                                    onLoad={() => {
                                                        if (this.imgRef.current) {
                                                            this.setState({
                                                                divDimensions: {
                                                                    width: this.imgRef.current.offsetWidth,
                                                                    height: this.imgRef.current.offsetHeight,
                                                                },
                                                            });
                                                        }
                                                    }}
                                                    style={{ width: "100%", height: "auto" }}
                                                    alt="Letterhead"
                                                />
                                            ) : (
                                                <div>
                                                    <h4 className="text-muted">Please Select Letter Head ✉...</h4>
                                                </div>
                                            )}
                                            {/* #3. */}
                                            {/* {letterhead_url ?
                                                pages?.map((val, index) => {
                                                    return (
                                                        <>
                                                            <div
                                                                className="bubble-editor"
                                                                ref={val?.ref}
                                                                style={{
                                                                    position: "absolute",
                                                                    width: divDimensions.width ? `${divDimensions.width}px` : "0",
                                                                    height: divDimensions.height ? `${divDimensions.height}px` : "0",
                                                                    paddingTop: letter_markings[0] + "mm",
                                                                    paddingBottom: letter_markings[1] + "mm",
                                                                    paddingLeft: letter_markings[2] + "mm",
                                                                    paddingRight: letter_markings[3] + "mm",
                                                                    maxHeight: divDimensions.height
                                                                        ? `${divDimensions.height - letter_markings[0] - letter_markings[1]}px`
                                                                        : "0", // Subtract top and bottom padding from height
                                                                    overflow: "hidden", // Use 'auto' if you want to make the content scrollable
                                                                    // border: "1px solid #ccc",
                                                                }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: previewClicked ? val?.content : "",
                                                                }}
                                                            />
                                                            <img
                                                                src={letterhead_url}
                                                                ref={this.imgRef}
                                                                onLoad={() => {
                                                                    if (this.imgRef.current) {
                                                                        this.setState({
                                                                            divDimensions: {
                                                                                width: this.imgRef.current.offsetWidth,
                                                                                height: this.imgRef.current.offsetHeight,
                                                                            },
                                                                        });
                                                                    }
                                                                }}
                                                                style={{ width: "100%", height: "auto" }}
                                                                alt="Letterhead"
                                                            />
                                                        </>
                                                    )
                                                }) :
                                                <div>
                                                    <h4 className="text-muted">Please Select Letter Head ✉...</h4>
                                                </div>
                                            } */}
                                            {/* </div> */}
                                        </div>
                                    </div>
                                </div>
                                {/* Preview Tab */}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default NewLetterSandBox;
